import { WordSpan } from './speechEngine'

export const MIN_WORD_SPAN_MS = 80

export const smoothWordSpans = (words: WordSpan[], minMs: number = MIN_WORD_SPAN_MS): WordSpan[] => {
  const spans: WordSpan[] = words.map(([start, end]) => [start, end])

  spans.forEach(([start, end], index) => {
    if (end - start >= minMs) { return }

    const wanted = start + minMs
    const next = spans[index + 1]
    if (!next) {
      spans[index] = [start, wanted]
      return
    }

    const [nextStart, nextEnd] = next
    const borrowedStart = Math.min(wanted, nextEnd - minMs)
    if (borrowedStart > nextStart) {
      spans[index] = [start, borrowedStart]
      spans[index + 1] = [borrowedStart, nextEnd]
    } else if (nextStart > end) {
      spans[index] = [start, Math.min(wanted, nextStart)]
    }
  })

  return spans
}
